'use client';

import { Box, Grid, Typography, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslations } from "next-intl";


const AirxpressCleaning = () => {
    const t = useTranslations("ServicePage.airxpress_cleaning");
    return (
        <Box sx={{ py: { xs: 8, md: 12 }, px: 2, backgroundColor: "#f8fafc" }}>
            <Box sx={{ maxWidth: "lg", margin: "auto" }}>
                {/* Header */}
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    <span className="inline-block bg-[#F15859] text-white text-xs font-normal px-6 py-1.5 rounded-full mb-6 shadow-sm">
                        {t('chip')}
                    </span>
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                        {t('title')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#64748b", maxWidth: "800px", mx: "auto" }}>
                        {t('description')}
                    </Typography>
                </Box>

                <Grid container spacing={4} sx={{ mb: 8 }}>
                    {/* Column 1: Content */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{ height: "100%", backgroundColor: "white", borderRadius: "24px", p: 4, border: "1px solid #e2e8f0" }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 3, textAlign: "left" }}>
                                {t('col1_title')}
                            </Typography>
                            <Stack spacing={2}>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold ", color: "#1e293b", }}>{t('service_1_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('service_1_desc')}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('service_2_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('service_2_desc')}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('service_3_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('service_3_desc')}</Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Grid>

                    {/* Column 2: Automation */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{ height: "100%", backgroundColor: "white", borderRadius: "24px", p: 4, border: "1px solid #e2e8f0" }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 3, textAlign: "left" }}>
                                {t('col2_title')}
                            </Typography>
                            <Stack spacing={2}>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('auto_1_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('auto_1_desc')}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('auto_2_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('auto_2_desc')}</Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Grid>

                    {/* Column 3: Area */}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{ height: "100%", backgroundColor: "white", borderRadius: "24px", p: 4, border: "1px solid #e2e8f0" }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 3, textAlign: "left" }}>
                                {t('col3_title')}
                            </Typography>
                            <Stack spacing={1}>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('area_1_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('area_1_desc')}</Typography>
                                </Box>
                                <Box>
                                    <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#1e293b" }}>{t('area_2_title')}</Typography>
                                    <Typography variant="caption" sx={{ color: "#64748b" }}>{t('area_2_desc')}</Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ textAlign: "center", mb: 4 }}>
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2 }}>
                        {t('pricing_title')}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#64748b" }}>
                        {t('pricing_desc')}
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {/* Table */}
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, height: "100%", border: "1px solid #e2e8f0" }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2 }}>
                                {t('ref_price_title')}
                            </Typography>
                            <TableContainer sx={{ overflowX: "auto" }}>
                                <Table size="small" sx={{ minWidth: 650 }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", whiteSpace: "nowrap" }}>{t('th_area')}</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", whiteSpace: "nowrap" }}>{t('th_capacity')}</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", whiteSpace: "nowrap" }}>{t('th_price')}</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", whiteSpace: "nowrap" }}>{t('th_extra')}</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", whiteSpace: "nowrap" }}>{t('th_time')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[
                                            { size: "~25㎡", capacity: "1~2名", price: "4,000円", extra: "-", time: "45~60分" },
                                            { size: "26~35㎡", capacity: "2~3名", price: "4,500円", extra: "+500円/1名超過", time: "60分" },
                                            { size: "36~45㎡", capacity: "3~4名", price: "5,500円", extra: "+500円/1名超過", time: "60~75分" },
                                            { size: "46~60㎡", capacity: "4~5名", price: "6,500円", extra: "+700円/1名超過", time: "75~90分" },
                                            { size: "61~80㎡", capacity: "5~6名", price: "8,000円", extra: "+700円/1名超過", time: "90~110分" },
                                            { size: "81~100㎡", capacity: "6~7名", price: "9,500円", extra: "+1,000円/1名超過", time: "110~130分" },
                                            { size: "101~120㎡", capacity: "7~8名", price: "11,000円", extra: "+1,000円/1名超過", time: "130~150分" },
                                            { size: "121㎡以上", capacity: "8名以上", price: "13,000円~", extra: "別途お見積もり", time: "150分~" },
                                        ].map((row) => (
                                            <TableRow key={row.size}>
                                                <TableCell sx={{ color: "#334155", fontWeight: "normal", borderBottom: "1px solid #f1f5f9" }}>{row.size}</TableCell>
                                                <TableCell align="left" sx={{ color: "#64748b", borderBottom: "1px solid #f1f5f9" }}>{row.capacity}</TableCell>
                                                <TableCell align="left" sx={{ color: "#334155", fontWeight: "normal", borderBottom: "1px solid #f1f5f9" }}>{row.price}</TableCell>
                                                <TableCell align="left" sx={{ color: "#64748b", borderBottom: "1px solid #f1f5f9" }}>{row.extra}</TableCell>
                                                <TableCell align="left" sx={{ color: "#64748b", borderBottom: "1px solid #f1f5f9" }}>{row.time}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Typography variant="caption" sx={{ display: "block", mt: 2, color: "#94a3b8", fontSize: "0.75rem" }}>
                                {t('pricing_note')}
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Options */}
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <Box sx={{ backgroundColor: "white", borderRadius: "16px", p: 3, height: "100%", border: "1px solid #e2e8f0" }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#1e293b", mb: 3 }}>
                                {t('options_title')}
                            </Typography>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", width: "50%" }}>{t('opt_th_name')}</TableCell>
                                            <TableCell align="left" sx={{ fontWeight: "bold", color: "#1e293b", borderBottom: "none", width: "50%" }}>{t('opt_th_price')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[
                                            { nameKey: "opt_1_name", priceKey: "opt_1_price" },
                                            { nameKey: "opt_2_name", priceKey: "opt_2_price" },
                                            { nameKey: "opt_3_name", priceKey: "opt_3_price" },
                                            { nameKey: "opt_4_name", priceKey: "opt_4_price" },
                                        ].map((row) => (
                                            <TableRow key={row.nameKey}>
                                                <TableCell sx={{ color: "#334155", fontWeight: "normal", borderBottom: "1px solid #f1f5f9", width: "50%" }}>{t(row.nameKey)}</TableCell>
                                                <TableCell align="left" sx={{ color: "#334155", fontWeight: "normal", borderBottom: "1px solid #f1f5f9", width: "50%" }}>{t(row.priceKey)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default AirxpressCleaning;